import {Component, Input, OnChanges} from '@angular/core';
import {ConceptsContainer} from '../../../core/definitions/concepts-container';
import {ConceptMenu} from '../../admin-concept-lists/concept-menu';
import {ConceptService} from '../../../core/concept.service';
import {OperationService} from '../../../operations/operation.service';
import {OperationTarget} from '../../../core/definitions/operation-target.enum';
import {OperationContainer} from '../../../core/definitions/operation-container';
import {Subscription} from 'rxjs';
import {OperationDef} from '../../../core/definitions/operation-def';
import {SuperObjectModel} from '../../../core/definitions/super-object-model';
import {OperationDialogService} from '../../../operations/operation-dialog.service';
import {ConceptMetaOperationService} from '../../admin-concept-lists/concept-meta-operation.service';

@Component({
  selector: 'app-admin-action-list-menu',
  templateUrl: './admin-action-list-menu.component.html',
  styleUrls: ['./admin-action-list-menu.component.scss']
})
export class AdminActionListMenuComponent implements OnChanges {

  constructor(private conceptService: ConceptService,
              private conceptMetaOperationService: ConceptMetaOperationService,
              private operationService: OperationService,
              private operationDialogService: OperationDialogService) {
  }

  @Input() conceptsContainer: ConceptsContainer;
  @Input() selectedItemLength: number; // this will cause ngOnChange when selecting items

  menus: Array<ConceptMenu> = [];
  operationContainer: OperationContainer;

  selectSubscription: Subscription;

  async openOperation(operation: OperationDef) {
    await this.operationService.openOperationView(this.operationContainer, operation, null,
      operationRes => {
        console.log('Operation res: ' + operationRes);
      }
    );
  }

  ngOnChanges(): void {
    if (!this.operationContainer) {
      this.setOperationContainer().then();
    } else {
      this.setOperations().then();
    }
  }

  private async setOperationContainer(): Promise<void> {
    this.operationContainer = await this.operationService.createOperationContainer(OperationTarget.ADMIN_LIST_VIEW);
    this.operationContainer.refreshFn = () => {
      this.conceptService.clearSelected(this.conceptsContainer);
      this.conceptsContainer.conceptDataSource.loadConcepts(this.conceptsContainer);
    };
    this.operationContainer.openOperationDialogFn = (callback) => {
      this.operationDialogService.openOperationDialog(this.operationContainer).then(data => {
        if (callback) {
          callback(data);
        }
      });
    };

    this.menus = await this.conceptMetaOperationService.getOperations(this.conceptsContainer);
  }

  private async setOperations() {
    this.operationContainer.operationContextObjects = this.conceptsContainer.selected.map(conceptListItem => {
      const superObject = new SuperObjectModel();
      superObject.artifact_id = conceptListItem.artifact_id;
      superObject.artifact_name = conceptListItem.artifact_name;
      superObject.object_type = conceptListItem.object_type;
      superObject.meta_type = conceptListItem.meta_type;
      superObject.superobject_type_id = conceptListItem.superobject_type_id;
      superObject.authority_id = conceptListItem.authority_id;
      return superObject;
    });
    await this.operationService.setOperations(this.operationContainer);
  }

}
